import { User, WebStorageStateStore } from "oidc-client-ts";
import { AuthProviderProps } from "react-oidc-context";

const onSigninCallback = (_user: User | void): void => {
  window.history.replaceState(
      {},
      document.title,
      window.location.pathname
  )
};

const defaultProperties: AuthProviderProps = {
  authority: window.plasma.environment.AUTH_PROVIDER_PROPS__AUTHORITY as string,
  client_id: window.plasma.environment.AUTH_PROVIDER_PROPS__CLIENT_ID as string,
  redirect_uri: window.location.origin + window.location.pathname,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Enables redirect to your application root path ("/") after logout
  post_logout_redirect_uri: window.location.origin,
  onSigninCallback,
  automaticSilentRenew: true,
};

export default defaultProperties as AuthProviderProps;
